module.exports = __webpack_public_path__ + "static/media/DINNextRoundedLTPro-Light.4722f6e0.otf";